import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DriverActionCreators from 'actions/DriverActionCreators';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import SessionStore from 'stores/SessionStore';
import ShipmentStore from 'stores/ShipmentStore';
import DriverStore from 'stores/DriverStore';
import MarkerFactory from 'components/shipment/maps/MarkerFactory';
import MapView from 'components/shipment/maps/MapView';
import JobDetails from 'components/modules/shipments/tracking/JobDetails';

const POLLING_INTERVAL = 10000;

function fetchAuthorizedDrivers() {
  const carrier = SessionStore.getUser();
  if (carrier) {
    DriverActionCreators.getAuthorizedDriversForCarrier(carrier._id);
  }
}

export default class ShipperTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: [],
      drivers: [],
      shipment: null,
    };
  }
  componentDidMount() {
    this.startPolling();
    ShipmentStore.addChangeListener(this.handleShipmentChange);
    DriverStore.addChangeListener(this.handleDriversChange);
  }

  componentWillUnmount() {
    this.stopPolling();
    ShipmentStore.removeChangeListener(this.handleShipmentChange);
    DriverStore.removeChangeListener(this.handleDriversChange);
  }

  getShipmentId() {
    const {
      match: {
        params: { id },
      },
    } = this.props;
    return id;
  }

  fetchShipment() {
    ShipmentsActionCreators.getShipmentV2(this.getShipmentId());
  }

  pollAuthorizedDrivers() {
    fetchAuthorizedDrivers();
    this.authorizedDriversInterval = setTimeout(() => {
      this.pollAuthorizedDrivers();
    }, 10000);
  }

  pollShipment = () => {
    this.fetchShipment();
    this.pollShipmentInterval = setTimeout(() => {
      this.pollShipment();
    }, POLLING_INTERVAL);
  };

  startPolling() {
    this.pollShipment();
    this.pollAuthorizedDrivers();
  }

  stopPolling() {
    clearTimeout(this.pollShipmentInterval);
    clearTimeout(this.authorizedDriversInterval);
  }

  handleDriversChange = () => {
    const drivers = DriverStore.getAuthorizedDrivers();

    this.setState({
      drivers,
    });
  };

  handleShipmentChange = () => {
    const shipment = ShipmentStore.getShipment(this.getShipmentId());
    let markers = [];

    if (shipment.driver && !shipment.driver.carrier) {
      shipment.driver.carrier = shipment.carrier;
    }

    if (shipment) {
      document.title = shipment.shipment_id;
      markers = MarkerFactory.createMarkersForShipment(shipment) || [];
      if (markers.length > 0) {
        if (!shipment.current) {
          markers = markers.filter(
            (marker) =>
              marker.info === 'Origin' || marker.info === 'Destination',
          );
        }
      }
    }

    this.setState({ shipment, markers });
  };

  render() {
    if (!this.state.shipment) return null;

    const closeButtonVisible = false;

    return (
      <div>
        <div
          className="shipments-tracking"
          style={{ position: 'absolute', zIndex: 2 }}
        >
          <JobDetails
            job={this.state.shipment}
            activeDriver={this.state.shipment.driver}
            closeButtonVisible={closeButtonVisible}
            drivers={this.state.drivers}
            showPayoutTab={this.props.showPayoutTab}
          />
        </div>
        <div
          style={{
            zIndex: -999,
            width: '100vw',
          }}
        >
          <MapView
            fitMarkers
            id="shipment-map"
            height="100vh"
            markers={this.state.markers}
            initZoom={10}
          />
        </div>
      </div>
    );
  }
}

ShipperTracking.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  showPayoutTab: PropTypes.bool,
};
